var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSwingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_2895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 12.8333C10.2215 12.8333 12.8332 11.9192 12.8332 10.7917C12.8332 9.66409 10.2215 8.75 6.99984 8.75C3.77818 8.75 1.1665 9.66409 1.1665 10.7917C1.1665 11.9192 3.77818 12.8333 6.99984 12.8333Z",
    stroke: "#006AB3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.4998V1.1665",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.0415L10.1631 3.623C11.0737 4.07832 11.529 4.30598 11.529 4.6665C11.529 5.02703 11.0737 5.25468 10.1631 5.71001L7 7.2915",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_2895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSwingsIcon);
export default __webpack_public_path__ + "static/media/total_swings_icon.4e64805fcbed41f6916d80854f652735.svg";
export { ForwardRef as ReactComponent };